import ReferencePathService from '~/services/referencePathServices/referencePathService'
import {
  IReferencePathNodeApiConnection,
  IReferencePathNodeSpecific
} from '~/interfaces/referencePathInterfaces'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import ExternalConnection from '~/models/externalConnections/externalConnection'

export default class ApiConnectionPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.API

  constructor(private connectionNode: IReferencePathNodeApiConnection) {
    super()
  }

  get label(): string {
    return this.connectionNode.reference()?.name
  }

  get nodes(): IReferencePathNodeApiConnection[] {
    return [this.connectionNode]
  }

  reference(): ExternalConnection {
    return ExternalConnection.repo.findById(this.connectionNode.reference_id)
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    const endpoint = this.reference().endPointsArray().find((e) => e.id === node.reference_id)
    const decision = !!endpoint
    this.debugCanLinkTo('ApiConnectionPathService', this.connectionNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return false
  }
}